<template>
  <div
    class="comp-container"
    :class="{
      'comp-container__h5': isH5,
      'comp-container__landscape': isLandscape,
    }"
  >
    <div class="current-time time">
      <span>{{ formatTime(currentTime) }}</span
      ><span v-if="isH5"> / {{ formatTime(initDuration) }}</span>
    </div>
    <div class="draggable-progress-bar">
      <div
        class="progress"
        :style="{ width: `${currentProgress * 100}%` }"
      ></div>
      <input
        v-if="initDuration"
        ref="range"
        class="range"
        type="range"
        min="0"
        step="0.000001"
        max="100"
        :value="currentProgress * 100"
        @input="inputValue"
        @change="changeValue"
        @mousedown="touchstart"
        @mouseup="touchend"
        @touchstart="touchstart"
        @touchend="touchend"
        @keydown="keydown"
      />
    </div>
    <div v-if="!isH5" class="total-time time">
      {{ formatTime(initDuration) }}
    </div>
  </div>
</template>

<script>
import { isH5, isMobile } from "@saas/components/src";
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    initCurrentTime: {
      type: Number,
      default: 0,
    },
    initDuration: {
      type: Number,
      default: 0,
    },
    isLandscape: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      handler(newValue) {
        if (this.isDraging) {
          return;
        }
        this.currentProgress = newValue;
      },
      immediate: true, // 初始化时同步设置 currentProgress
    },
    initCurrentTime: {
      handler(newValue) {
        if (newValue) {
          this.currentTime = newValue;
        } else {
          this.currentTime = 0;
        }
      },
      immediate: true, // 初始化时同步设置 currentProgress
    },
  },
  data() {
    return {
      currentProgress: 0,
      currentTime: 0,
      isH5: isMobile(),
      isDraging: false,
    };
  },
  mounted() {},
  methods: {
    touchend() {
      this.isDraging = false;
    },
    touchstart() {
      this.isDraging = true;
    },
    inputValue(e) {
      this.currentProgress = e.target.value / 100;
      this.currentTime = this.currentProgress * this.initDuration;
    },
    changeValue(e) {
      this.currentProgress = e.target.value / 100;
      this.$emit("change", e.target.value / 100);
    },
    // 格式化时间 00:00:00 ，不够小时不显示
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);
      return `${hours < 10 ? "0" + hours : hours}:${
        minutes < 10 ? "0" + minutes : minutes
      }:${secs < 10 ? "0" + secs : secs}`;
    },
    keydown(e) {
      e.preventDefault();
    },
    // 判断是否手机端并且横屏
    // isLandscape() {
    //   if (isMobile()) {
    //     return window.innerWidth > window.innerHeight;
    //   } else {
    //     return false;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  .time {
    color: #fff;
    font-size: 20px;
    line-height: 28px;
  }
  .draggable-progress-bar {
    margin: 0 16px;
    flex: 1;
    position: relative;
    width: 100%;
    height: 4px;
    background: rgba(217, 217, 217, 0.4);
    border-radius: 2px;
    .progress {
      position: absolute;
      width: 100%;
      height: 100%;
      background: linear-gradient(136deg, #00eb81 0%, #00c89d 100%);
      border-radius: 2px;
    }
    .range {
      position: absolute;
      width: 100%;
      height: 0;
      top: 50%;
      cursor: pointer;
      transform: translateY(-50%);
      appearance: none; /* 移除默认样式 */
      -webkit-appearance: none; /* 针对 WebKit 内核的浏览器 */
      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 20px;
        height: 20px;
        background-color: #fff;
        border-radius: 50%;
        cursor: pointer;
      }

      &:hover::-webkit-slider-thumb {
        box-shadow: 0px 0px 10px 4px rgba(0, 200, 157, 0.28);
      }

      &:active::-webkit-slider-thumb {
        box-shadow: 0px 0px 10px 4px rgba(0, 200, 157, 0.28);
      }
    }
  }
}

.comp-container__h5 {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 0.9867rem;
  align-items: flex-start;
  .time {
    font-size: 0.4rem;
    line-height: 0.56rem;
    height: 0.56rem;
    flex: 1;
  }
  .draggable-progress-bar {
    margin: 0;
    flex: none;
    margin-top: 0.1067rem;
    position: relative;
    width: 100%;
    height: 0.0533rem;
    background: rgba(217, 217, 217, 0.4);
    border-radius: 0.0267rem;
    .progress {
      border-radius: 0.0267rem;
    }
    .range {
      position: absolute;
      width: 100%;
      height: 0;
      top: 50%;
      cursor: pointer;
      transform: translateY(-50%);
      appearance: none; /* 移除默认样式 */
      -webkit-appearance: none; /* 针对 WebKit 内核的浏览器 */
      &::-webkit-slider-thumb {
        width: 0.32rem;
        height: 0.32rem;
        box-shadow: 0px 0px 0.1333rem 0.0533rem rgba(0, 200, 157, 0.28);
      }
    }
  }
}
.comp-container__landscape {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 0.4688rem;
  align-items: flex-start;
  .time {
    font-size: 0.1875rem;
    line-height: 0.25rem;
    height: 0.25rem;
    flex: 1;
  }
  .draggable-progress-bar {
    margin: 0;
    flex: none;
    margin-top: 0.0625rem;
    position: relative;
    width: 100%;
    height: 0.0625rem;
    background: rgba(217, 217, 217, 0.4);
    border-radius: 0.0313rem;
    .progress {
      border-radius: 0.0125rem;
    }
    .range {
      position: absolute;
      width: 100%;
      height: 0;
      top: 50%;
      cursor: pointer;
      transform: translateY(-50%);
      appearance: none; /* 移除默认样式 */
      -webkit-appearance: none; /* 针对 WebKit 内核的浏览器 */
      &::-webkit-slider-thumb {
        width: 0.1563rem;
        height: 0.1563rem;
        box-shadow: 0px 0px 0.1333rem 0.0533rem rgba(0, 200, 157, 0.28);
      }
    }
  }
}
input {
  outline: none;
}
</style>
